/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mirrors the database enum company_webhook_status. `failed` means FreightSimple stopped sending after repeated failures.
 * @export
 */
export const CompanyWebhookStatus = {
    Active: 'active',
    Inactive: 'inactive',
    Failed: 'failed'
} as const;
export type CompanyWebhookStatus = typeof CompanyWebhookStatus[keyof typeof CompanyWebhookStatus];


export function instanceOfCompanyWebhookStatus(value: any): boolean {
    for (const key in CompanyWebhookStatus) {
        if (Object.prototype.hasOwnProperty.call(CompanyWebhookStatus, key)) {
            if (CompanyWebhookStatus[key as keyof typeof CompanyWebhookStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompanyWebhookStatusFromJSON(json: any): CompanyWebhookStatus {
    return CompanyWebhookStatusFromJSONTyped(json, false);
}

export function CompanyWebhookStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyWebhookStatus {
    return json as CompanyWebhookStatus;
}

export function CompanyWebhookStatusToJSON(value?: CompanyWebhookStatus | null): any {
    return value as any;
}

export function CompanyWebhookStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CompanyWebhookStatus {
    return value as CompanyWebhookStatus;
}

